<template>
    <modal id="job-post-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('Job Post')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.JOB_POST'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('title')"
                        type="text"
                        v-model="formData.title"
                        :placeholder="$placeholder('title')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'title')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('job_position')"
                        list-value-field="title"
                        v-model="formData.job_position_id"
                        :chooseLabel="$t('job_position')"
                        :error-message="$errorMessage(errors, 'job_position_id')"
                        :fetch-url="SELECTABLE_JOB_POSITION"
                    />
                </div>
            </div>
            <app-form-group
                :label="$t('description')"
                type="textarea"
                v-model="formData.description"
                :placeholder="$textAreaPlaceHolder('description')"
                :required="true"
                :error-message="$errorMessage(errors, 'description')"
            />
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('manager')"
                        :chooseLabel="$t('manager')"
                        type="search-select"
                        list-value-field="full_name"
                        v-model="formData.manager_id"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_DEPARTMENT_USERS}?without=admin&employee=only&with_auth=yes`"
                        :required="true"
                        :error-message="$errorMessage(errors, 'manager_id')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('skill_zone')"
                        list-value-field="title"
                        type="search-select"
                        v-model="formData.skill_id"
                        :chooseLabel="$t('skill_zone')"
                        :required="false"
                        :fetch-url="`${apiUrl.SELECTABLE_SKILL_ZONE }`"
                        :error-message="$errorMessage(errors, 'skill_id')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('start_date')"
                        type="date"
                        v-model="formData.start_date"
                        :placeholder="$placeholder('start_date')"
                        :required="false"
                        :error-message="$errorMessage(errors, 'start_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('end_date')"
                        type="date"
                        v-model="formData.end_date"
                        :placeholder="$placeholder('end_date')"
                        :required="false"
                        :error-message="$errorMessage(errors, 'end_date')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('vacancy')"
                        type="number"
                        v-model="formData.vacancy"
                        :placeholder="$placeholder('vacancy')"
                        :required="false"
                        :error-message="$errorMessage(errors, 'vacancy')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('jobPost.is_published')"
                        v-model="formData.is_published"
                        type="radio"
                        :radio-checkbox-name="'published'"
                        :list="[{'id': 1, 'value': 'True'}, {'id': 0, 'value': 'False'}]"
                        :error-message="$errorMessage(errors, 'is_published')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('jobPost.is_profile')"
                        type="radio"
                        :radio-checkbox-name="'profile'"
                        :list="[{'id': 1, 'value': 'True'}, {'id': 0, 'value': 'False'}]"
                        v-model="formData.is_profile"
                        :error-message="$errorMessage(errors, 'is_profile')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('jobPost.is_resume')"
                        type="radio"
                        :radio-checkbox-name="'resume'"
                        :list="[{'id': 1, 'value': 'True'}, {'id': 0, 'value': 'False'}]"
                        v-model="formData.is_resume"
                        :error-message="$errorMessage(errors, 'is_resume')"
                    />
                </div>
            </div>
        </form>

    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {errorMessageInArray, formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";
import {SELECTABLE_JOB_POSITION, SELECTABLE_SKILL_ZONE} from "../../../../Config/ApiUrl";

export default {
    name: "JobPostCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                is_published: 1,
                is_profile: 0,
                is_resume: 1,
            },
            SELECTABLE_JOB_POSITION,
            SELECTABLE_SKILL_ZONE,
        };
    },
    computed: {},
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.JOB_POST;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#job-post-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'job-post-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#job-post-modal').modal('hide');
            this.toastAndReload(data.message, 'job-post-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
